<template lang="pug">
.opened-single-coupon-tab
  .free-coupons(:class="{'ladder-blend': ['ladder_blend', 'ladder_blend_two'].includes(version)}")
    .packet-block(
      v-for="item in freeList"
      :class="{'white-mask': isMask(item),\
       'ladder-blend': ['ladder_blend', 'ladder_blend_two'].includes(version)}"
    )
      .bussiness {{item.goodsPropDesc}}
      .price
        .num {{item.amount}}
        .yuan {{item.unit}}
      .no-threshold {{item.subWord}}
      .receive-button(@click="receiveCoupon(item)"
                      :style="getFontSize(getName(item.btnName),true)") {{getName(item.btnName)}}
  template(v-if="more")
    .divider(v-if="version === 'ladder_blend'||version === 'ladder_blend_two'")
    img.more-coupons-bar(v-else src="https://m.hellobike.com/resource/helloyun/22042/bNLNPwJNkL.png")
</template>

<script>
import Lottie from '@/components/lottie';
import { desc, getName, getFontSize } from '../utils.js';

export default {
  components: {
    Lottie,
  },
  props: {
    groupList: {
      type: Array,
      required: true,
    },
    more: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    version() {
      if (this.getPropVersion) {
        return this.getPropVersion();
      }
      return '';
    },
    freeList() {
      if (this.groupList && this.groupList.length > 0) {
        return this.groupList[0].propList || [];
      }
      return [];
    },
  },
  inject: ['getPropVersion'],
  methods: {
    getFontSize,
    desc,
    getName,
    receiveCoupon(item) {
      this.$emit('clickReceiveButton', item);
    },
    isMask(item) {
      return ![1, 2, 8].includes(item.status);
    },
  },
};
</script>
<style lang="less" scoped>
.opened-single-coupon-tab {
  .free-coupons {
    display: flex;
    justify-content: flex-start;
    overflow-x: auto;
    flex-shrink: 0;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
      color: transparent;
    }

    .white-mask {
      opacity: 0.4;
    }

    .packet-block {
      min-width: 0.78rem;
      height: 1.02rem;
      background: #fff;
      box-shadow: 0 0.02rem 0.04rem 0 rgba(241, 241, 241, 0.53);
      border-radius: 0.12rem;
      background-image: url(https://m.hellobike.com/resource/helloyun/22042/plsj5GW069.png);
      background-size: 100% 100%;
      margin: 0 0.05rem 0.19rem 0;
      // display: flex;
      // flex-direction: column;
      // justify-content: center;
      // align-items: center;

      &:last-child {
        margin-right: 0;
      }

      .bussiness {
        margin: 0 auto;
        padding-top: 0.02rem;
        width: fit-content;
        height: 0.12rem;
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #7d3b2a;
        line-height: 0.12rem;
      }

      .price {
        margin-top: 0.05rem;
        display: flex;
        justify-content: center;
        align-items: flex-end;

        .num {
          height: 0.28rem;
          font-size: 0.26rem;
          font-family: DINAlternate-Bold, DINAlternate, sans-serif;
          font-weight: bold;
          color: #fa4614;
          line-height: 0.28rem;
        }

        .yuan {
          margin: 0 0 0.05rem 0.01rem;
          width: 0.11rem;
          height: 0.11rem;
          font-size: 0.11rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #f54311;
          line-height: 0.11rem;
        }
      }

      .no-threshold {
        margin: 0 auto;
        width: fit-content;
        height: 0.16rem;
        font-size: 0.11rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #b16652;
        line-height: 0.16rem;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .receive-button {
        margin: 0.16rem auto 0 auto;
        width: fit-content;
        height: 0.16rem;
        font-size: 0.12rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        color: #7d3b2a;
        line-height: 0.16rem;
      }

      &.ladder-blend {
        background-image: url(https://m.hellobike.com/resource/gallery/43/A9YFJSrN_Group%201707482284.png);
        width: 0.78rem;
        height: 1.06rem;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: bottom center;

        .bussiness {
          margin-top: 0.08rem;
          height: 0.12rem;
          line-height: 0.12rem;
          text-align: center;
          color: #5a6066;
          font-family: "PingFang SC", sans-serif;
          font-weight: 500;
          font-size: 0.11rem;
        }

        .receive-button {
          margin-top: 0.11rem;
          text-align: center;
          box-sizing: border-box;
          overflow: hidden;
          min-width: 0.56rem;
          max-width: 0.68rem;
          padding: 0 0.03rem;
          color: #7d3b2a;
          height: 0.2rem;
          line-height: 0.2rem;
          background: linear-gradient(94.85deg, #ffe9d0 17.2%, #ffdcb4 98.24%);
          border-radius: 0.1rem;
        }
      }
    }
  }

  .more-coupons-bar {
    width: 3.27rem;
    height: 0.32rem;
    margin-bottom: 0.12rem;
  }

  .divider {
    border-bottom: 0.01rem solid rgba(240, 243, 245, 0.5);
    margin-bottom: 0.179rem;
  }
}
</style>
